import { GMI, STATE } from "../../constants";
import { types } from "../../utils/js/types";

const { REPLACEMENT } = STATE.UI;

/**
 * @desc Gets data from replacement.pickup_location to be saved to gmi.ui.replacement.pickup_location state
 * @param {Immutable} session - GMA
 * @returns {Object}
 */
export function getPickupLocationState(session) {
  const pickupLocationState = session
    .getIn(["replacement", "ticket", "pickup_location"])
    ?.toJS();

  if (!pickupLocationState) return;

  return pickupLocationState;
}

/**
 * Action creator for setting pickup location field
 * @param {String} path - Dot notation path of the field
 * @param {Any} value - Value to set
 * @returns {Object} Action object
 */
const setPickupLocationState = (path, value) => ({
  type: GMI.SET_GMI_STATE,
  path: REPLACEMENT.PICKUP_LOCATION,
  value
});

/**
 * Action creator for clearing pickup location field
 * @param {String} path - Dot notation path of the field
 * @param {Any} value - Value to set
 * @returns {Object} Action object
 */
const clearPickupLocationState = (path, value) => ({
  type: GMI.SET_GMI_STATE,
  path: REPLACEMENT.PICKUP_LOCATION,
  value
});

export const pickupLocationState = {
  /**
   * @name set
   * @desc A global setter for ui.replacement.pickup_location data
   * @param {String} [type] - Type of the field to set
   * @param {Object} [args] - Value to set
   * @returns {Function} Dispatch function
   * @memberof actions.replacement
   * @example
   *
   * // Set pickup location option
   * store.dispatch(pickupLocationState.set(null, opts.pickupLocationState))
   *
   * // Unset
   * store.dispatch(pickupLocationState.unset(null)
   */
  set(type = null, args = {}) {
    if (!types(type).isString) {
      return (dispatch) => dispatch(setPickupLocationState(null, args));
    }
  },

  /**
   * @name unset
   * @desc A global unsetter for ui.replacement.pickup_location data
   * @param {String} [type] - Type of the field to set
   * @returns {Function} Dispatch function
   * @memberof actions.replacement
   *
   */
  unset(type = null) {
    return (dispatch) => {
      if (!types(type).isString) {
        dispatch(clearPickupLocationState());
      }
    };
  }
};
